var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"670px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"botonCircularGrande",attrs:{"color":"#3f9aae","outlined":"","x-large":"","fab":"","ripple":false}},on),[_c('icono',{attrs:{"value":_vm.iconoDescargar,"nombreIcono":"Descargar"}})],1)]}}]),model:{value:(_vm.dialogo),callback:function ($$v) {_vm.dialogo=$$v},expression:"dialogo"}},[_vm._v(" "),_c('tarjeta-descargar',{attrs:{"documentos":_vm.documentos}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b70af60","hasScoped":true,"buble":{"transforms":{}}}!./src/components/DescargarArchivoV2/DescargarArchivoV2.html
// module id = 868
// module chunks = 0